import { POST_FAQ_ERROR, POST_FAQ_START, POST_FAQ_SUCCESS } from '../../types';

export default function post_faqs(state, action) {
  switch (action.type) {
    case POST_FAQ_START:
      return { ...state };
    case POST_FAQ_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case POST_FAQ_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}